<script setup>
import { reactive } from 'vue';

const props = defineProps({
  brandLogos: {
    type: Array,
    // required: true,
    default: () => [
      {
        sponsorLogoImageSrc: '',
        // sponsorLogoImageWidth: '',
        // sponsorLogoImageHeight: '',
      },
    ],
  },
  adHeadline: {
    type: String,
    // required: true,
    default: 'Ad Title Text',
  },
  adHeadlineColor: {
    type: String,
    // required: true,
    default: 'rgba(255, 255, 255, 1)',
  },
  adTagline: {
    type: String,
    // required: true,
    default: 'Ad Tagline Text',
  },
  adTaglineColor: {
    type: String,
    // required: true,
    default: 'rgba(11, 11, 11, 1)',
  },
});

const styleObjectHeadline = reactive({
  color: props.adHeadlineColor,
});

const styleObjectTagline = reactive({
  color: props.adTaglineColor,
});
</script>

<template>
  <div class="pbl-branding">
    <img class="pbl-branding__logo" :src="props.brandLogos[0].sponsorLogoImageSrc" />

    <div class="pbl-branding__headline" :style="styleObjectHeadline">
      <span class="pbl-branding__headline-copy">{{ props.adHeadline }}</span>
    </div>

    <div class="pbl-branding__tagline" :style="styleObjectTagline">
      <span class="pbl-branding__tagline-copy">{{ props.adTagline }}</span>
    </div>
  </div>
</template>
